import { useMutation, useQueryClient } from 'react-query';
import {
  createCastRelationship,
  type CreateCastRelationshipBody,
  type CreateCastRelationshipResponse
} from '../../services/castRelationshipService';

export const useCreateCastRelationship = () => {
  const queryClient = useQueryClient();
  return useMutation<CreateCastRelationshipResponse, Error, CreateCastRelationshipBody>({
    mutationFn: (body) => createCastRelationship(body),
    onSuccess: () => {
      queryClient.invalidateQueries(['castRelationship']);
    }
  });
};
